"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgLargeSpinner = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 68 68", size: size }, props),
        react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.818 34.015c0-10.602 8.595-19.197 19.197-19.197 10.602 0 19.197 8.595 19.197 19.197 0 10.602-8.595 19.197-19.197 19.197-2.807 0-5.518-.6-8.005-1.743a5.41 5.41 0 00-4.518 9.83 29.923 29.923 0 0012.523 2.731c16.577 0 30.015-13.438 30.015-30.015C64.03 17.438 50.592 4 34.015 4 17.438 4 4 17.438 4 34.015a5.41 5.41 0 1010.818 0z", clipRule: "evenodd" })));
};
exports.default = SvgLargeSpinner;
//# sourceMappingURL=LargeSpinner.js.map